import React, { Component } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from '../../Apanel/QueryMe';

const apiurl = MY_API_URL;
import { Card, CardBody, Col, Row, Badge } from 'reactstrap';
const initialstate = {
	questats: [],
	token: localStorage.token,
};
class Dashboard extends Component {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };
	componentDidMount() {
		localStorage.setItem('gotodash', 0);
		if (localStorage.profile_completed === '0') {
			localStorage.setItem('came_from', 'dashboard');
			this.props.history.push({
				pathname: '/profile',
				backTo: '/',
			});
		} else {
			this.getQueStats(localStorage.token);
		}
	}
	getQueStats = (token) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			email: localStorage.by,
		};
		const getuurl = apiurl + 'getAuQueStats';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log(response.data.data);
				if (response.data.error) {
				} else {
					this.setState({
						questats: [...response.data.data],
					});
				}
			})
			.catch((error) => {
				localStorage.clear();
				this.props.history.push('/');
			});
	};
	render() {
		return (
			<Row>
				<Col md={4}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">Total</h5>
							</div>
							<p>
								<Badge style={{ fontSize: '15px' }} color="primary">
									{this.state.questats[0]}
								</Badge>
							</p>
						</CardBody>
					</Card>
				</Col>
				<Col md={4}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">Approved</h5>
							</div>
							<p>
								<Badge style={{ fontSize: '15px' }} color="success">
									{this.state.questats[1]}
								</Badge>
							</p>
						</CardBody>
					</Card>
				</Col>
				<Col md={4}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">Pending</h5>
							</div>
							<p>
								<Badge style={{ fontSize: '15px' }} color="warning">
									{this.state.questats[2]}
								</Badge>
							</p>
						</CardBody>
					</Card>
				</Col>
			</Row>
		);
	}
}

export default Dashboard;
